/*
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:03:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-09-05 17:01:36
 */
export const initSearch = {
  data() {
    return {

    }
  },
  methods: {

  },
  watch: {
    '$route' (to, from) {
      this.initWatchRouteChange()
    },
  },
  mounted() {}
}
